import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../../css/public/refund-policy.css';
import TopBar from './NavBar';
import Footer from './../components/Footer';

const RefundPolicy = () => {
  useEffect(() => {
    document.title = 'Refund Policy | Aadow';
	  }, []);
 

  return (
    <div class="refund-policy-body">
	<TopBar/> 
	<div class="top-area">
      <div class="container-top text-center">
        <h1>REFUND POLICY</h1>
		<span>Update on 23 Jul 2023</span>
      </div>
    </div>
    <div class="content-area"> 
	
	<div class="policy-content shadow-sm">
	
	  <p>At Aadow, we strive to provide high-quality services and ensure customer satisfaction. However, please carefully review our refund policy before making any payment. Our refund policy is as follows:</p>

	  <h2>Payment Failure:</h2>
	  <p>In the event of a payment failure during the transaction process, we will promptly initiate a refund. You will be reimbursed for the full amount paid through the same payment method used for the original transaction.</p>

	  <h2>No Refunds for Services Rendered:</h2>
	  <p>Once payment is successfully made and our services are rendered, we do not generally offer refunds. We allocate significant time, effort, and resources to fulfill our obligations and provide the agreed-upon services.</p>

	  <h2>Exceptional Circumstances:</h2>
	  <p>In exceptional cases, such as a breach of contract on our part or failure to deliver the agreed-upon services, we may consider refund requests on a case-by-case basis. Our decision to grant a refund in such circumstances will be at our sole discretion.</p>

	  <h2>Non-Refundable Fees:</h2>
	  <p>Please note that certain fees and expenses associated with third-party services, licenses, or materials procured on your behalf may be non-refundable. Any such non-refundable fees will be clearly communicated to you before the purchase or engagement of those services.</p>

	  <h2>Process for Refunds:</h2>
	  <p>If you are eligible for a refund as per the terms mentioned above, please contact our customer support team within a reasonable time-frame to initiate the refund process. Once the necessary transaction details and documentation are provided and verified, the refund will be processed, and you can expect the refunded amount to be credited to your account within 7-14 working days.</p>
	  
	  <h2>WhatsApp Services Charges:</h2>
	  <p>Aadow provides WhatsApp messaging services via Meta’s official WhatsApp Business API. Charges for WhatsApp services are divided into two components:</p>

	  <ul>
	  <li><strong>Platform Fee:</strong> This is Aadow’s service charge for enabling and managing WhatsApp functionality. Our general refund policy applies to this fee. No refunds will be issued once services are rendered, except under exceptional circumstances as outlined above.</li>
	
	  <li><strong>Per Message Cost:</strong> This fee is charged by Aadow based on Meta’s official WhatsApp conversation-based pricing model. While Aadow collects this fee, it is directly dependent on Meta’s pricing structure and message delivery system. If a message fails to deliver and qualifies for a refund under Meta’s policies, the corresponding credit will be automatically applied to your Aadow account. Aadow does not offer manual refunds for per-message costs.</li>
	  </ul>

	  <p>Please note that per-message costs are usage-based and non-refundable except in cases where Meta issues a delivery-based credit. Users are responsible for reviewing and understanding Meta’s conversation-based billing model before usage. Aadow does not control Meta’s pricing or refund criteria.</p>

	  <p>
		 Please note that monthly plans are not eligible for refunds, and this policy applies exclusively to annual/yearly plans.
	  </p>

	  <p>This refund policy applies specifically to Aadow's services, including platform usage fees. It does not apply to third-party services such as Meta’s WhatsApp per-message billing. Any refund or adjustment related to such third-party services will follow their own policies and terms.</p>
	 

	</div>
	 
	</div>
	<Footer/>
    </div>
  );
};

export default RefundPolicy;
